import ReactDom from 'react-dom'
import Popper from 'popper.js'

import './download-popover.scss'

export default { show }

function show(target, context, cb) {
    const picturesCount = context.picturesCount
    const selectedCount = context.getSelectedCount()
    
    const dialog = (
        <div className='download-popover'>
            <h4>Downloads</h4>
            <div className='download-opt'>
                <label>Todas as fotos</label>
                <button onClick={() => select(false)} disabled={!picturesCount}>
                    <i className='fa fa-download'></i>
                    <span>{picturesCount} {picturesCount >= 1 ? 'fotos' : 'foto'}</span>
                </button>
            </div>
            <div className='download-opt'>
                <label>Fotos selecionadas</label>
                <button onClick={() => select('selecteds')} disabled={!selectedCount}>
                    <i className='fa fa-download'></i>
                    <span>{selectedCount} {selectedCount >= 1 ? 'fotos' : 'foto'}</span>
                </button>
            </div>
        </div>
    )

    const overlay = document.createElement('div')
    const host = document.createElement('div')
    overlay.className = 'download-popover-overlay'
    host.className = 'download-popover-wrap'

    ReactDom.render(dialog, host)
    
    overlay.addEventListener('click', close)
    // host.addEventListener('mouseleave', close)

    document.body.appendChild(overlay)
    document.body.appendChild(host)

    new Popper(target, host, { placement: 'bottom-start' })

    function close() {
        overlay.remove()
        host.remove()
    }

    function select(k) {
        close()
        if (typeof cb === 'function') cb(k)
    }
}
